import { useParams, Navigate } from "react-router-dom";
import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import JobDetailHero from "@/components/landing/careers/JobDetailHero";
import JobDetailContent from "@/components/landing/careers/JobDetailContent";
import { getJobPostBySlug } from "@/data/jobPosts";
import { useLanguage } from "@/hooks/useLanguage";
import {
  StructuredDataHead,
  LLMMetadataHead,
  organizationSchema,
  createWebPageSchema,
  createJobPostingSchema,
} from "@/hooks/useStructuredData";

const JobDetail = () => {
  const { slug } = useParams<{ slug: string }>();
  const { language } = useLanguage();
  const job = slug ? getJobPostBySlug(slug, language) : undefined;

  if (!job) {
    return <Navigate to="/karriere" replace />;
  }

  return (
    <div className="min-h-screen bg-background">
      <StructuredDataHead schemas={[
        organizationSchema,
        createWebPageSchema(
          `${job.title} | Karriere bei Chathero`,
          job.shortDescription,
          `/karriere/${job.slug}`,
          [
            { name: "Home", url: "/" },
            { name: language === "en" ? "Careers" : "Karriere", url: "/karriere" },
            { name: job.title, url: `/karriere/${job.slug}` },
          ]
        ),
        createJobPostingSchema({
          title: job.title,
          description: job.shortDescription,
          location: job.location,
          type: job.type,
          publishDate: job.publishDate,
          remote: job.remote,
          responsibilities: job.responsibilities,
          requirements: job.requirements,
        }),
      ]} />
      <LLMMetadataHead
        title={`${job.title} | Karriere bei Chathero`}
        description={job.shortDescription}
        keywords={`${job.title}, ${job.department} Jobs, Chathero Karriere, SaaS Jobs München`}
        canonicalUrl={`https://chathero.ai/karriere/${job.slug}`}
        aiCategory="Karriere, Stellenangebot"
        aiEntityType="Job Posting"
      />
      <Header />
      <main>
        <JobDetailHero job={job} />
        <JobDetailContent job={job} />
      </main>
      <Footer />
    </div>
  );
};

export default JobDetail;
